import { apiUrl } from '../../../settings'

export const addAgentReportUrl = () => {
  return apiUrl + '/addAgentReport'
}

export const listAgentReportsUrl = () => {
  return apiUrl + '/allAgentReports'
}
